import React from 'react';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-8 px-4 bg-gradient-to-b from-green-50 to-emerald-50/50" data-id="element-255">
      <div className="max-w-3xl mx-auto text-center" data-id="element-256">
        <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full font-bold mb-3" data-id="element-257">
          <Sparkles className="w-5 h-5" data-id="element-258" />
          💡 La buena noticia
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-259">
          No necesitás más tiempo. No necesitás ser una madre o un padre
          perfecto. No necesitás planes complicados.
        </h2>

        <p className="text-2xl font-medium text-green-700 mb-6" data-id="element-260">
          👉 Solo necesitás momentos guiados, simples y reales.
        </p>

        <div className="bg-white p-6 rounded-2xl shadow-xl border-2 border-green-100" data-id="element-261">
          <p className="text-gray-500 uppercase tracking-widest font-bold text-sm mb-1" data-id="element-262">
            Por eso creé:
          </p>
          <h3 className="text-4xl md:text-5xl font-black text-gray-900 mb-2" data-id="element-263">
            🌿 CREANDO RECUERDOS REALES
          </h3>
          <p className="text-xl text-gray-700 mb-4" data-id="element-264">
            Un sistema emocional simple para volver a conectar con tus hijos
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-left md:text-center mb-4" data-id="element-265">
            <div className="bg-green-50 p-3 rounded-lg" data-id="element-266">
              <span className="text-green-600 font-bold text-xl" data-id="element-267">✔</span>
              <p className="font-medium" data-id="element-268">estar más presente</p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg" data-id="element-269">
              <span className="text-green-600 font-bold text-xl" data-id="element-270">✔</span>
              <p className="font-medium" data-id="element-271">fortalecer el vínculo</p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg" data-id="element-272">
              <span className="text-green-600 font-bold text-xl" data-id="element-273">✔</span>
              <p className="font-medium" data-id="element-274">
                crear recuerdos que queden para siempre
              </p>
            </div>
          </div>

          <p className="text-xl font-bold text-gray-800" data-id="element-275">
            Sin pantallas. Sin estrés. Sin culpa.
          </p>
        </div>
      </div>
    </section>;
}